// merchant-pc 路由 (PR-22a-3 RFC-20260514-010)
// 路由命名严格对应 prototype merchant_pc.html#m00..#p11 屏 ID (PROJECT_RULES §3.2)
// 本 stub 仅含 m00-login 占位, PR-22b 业务页跟进时按 prototype 11 屏补全

import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'm00-login',
    component: () => import('@/views/m00-login/index.vue'),
    meta: { prototypeRef: 'merchant_pc.html#m00', requiresAuth: false },
  },
  // RFC-20260617-001: stylist self-service onboarding application form
  {
    path: '/apply',
    name: 'm00b-stylist-apply',
    component: () => import('@/views/m00b-stylist-apply/index.vue'),
    meta: { requiresAuth: false },
  },
  // PR2-G2 (2026-05-25) #8: 搭配师签约商户管理 = sp07 商家关联
  {
    path: '/signings',
    name: 's-merchant-signing',
    component: () => import('@/views/s-merchant-signing/index.vue'),
    meta: { requiresAuth: true },
  },
  // PR2-G4 (2026-05-25) #9: 搭配师收入屏 = sp06 收益 / 服务
  {
    path: '/income',
    name: 's-income',
    component: () => import('@/views/s-income/index.vue'),
    meta: { requiresAuth: true },
  },
  // PR3-E (2026-05-25): stylist-pc 5 缺屏
  {
    path: '/dashboard',
    name: 'sp02-dashboard',
    component: () => import('@/views/sp02-dashboard/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/customers',
    name: 'sp03-customers',
    component: () => import('@/views/sp03-customers/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/customers/:userId',
    name: 'sp04-customer-detail',
    component: () => import('@/views/sp04-customer-detail/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/reports/new',
    name: 'sp05-report-editor',
    component: () => import('@/views/sp05-report-editor/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/rebate',
    name: 'sp06b-rebate-detail',
    component: () => import('@/views/sp06b-rebate-detail/index.vue'),
    meta: { requiresAuth: true },
  },
];

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// PR2-G2 (2026-05-25): beforeEach guard (token + requiresAuth) 复用 merchant-pc/admin-pc 模式
router.beforeEach((to, _from, next) => {
  const requiresAuth = to.meta?.requiresAuth === true;
  const hasToken = !!localStorage.getItem('auth:token');
  if (requiresAuth && !hasToken) {
    if (to.path !== '/login') {
      next({ path: '/login', replace: true });
      return;
    }
  }
  next();
});
